import {
  FC,
  ReactNode,
  createContext,
  useState,
  useEffect,
  useContext,
} from "react";
import { ConnectionContext } from "./ConnectionProviderContext";
import { Program } from "@project-serum/anchor";
import { TweeterDapp } from "../types/tweeter_dapp";
import { Connection } from "@solana/web3.js";
import { getPublicKeys, getTweets } from "../utils/Pagination";
import { set } from "@project-serum/anchor/dist/cjs/utils/features";
import { LikeContext } from "./LikesContext";
import { TweetsInfo} from "../utils/TweetsLikes";
import { LikedByUser} from "../utils/UserLikes";
import setTweetsWithUserLike from "../utils/Tweets";

export const TweetsContext = createContext({
  allTweets: [],
  setPage: () => { },
});

const TweetsProvider = ({
  children,
}: {children: ReactNode}) => {
  const [allTweets, setAllTweets] = useState<any | null>([]);
  const { workSpace }: any = useContext(ConnectionContext);
  const { allLikes, userLikes, setFetch, fetchTweets }: any = useContext(LikeContext);
  const [pageNo, setPageNo] = useState<number>(1);
  // const [fetchTweets, setFetchTweets] = useState<boolean>(false);
  const program = workSpace.program as Program<TweeterDapp>;
  const connection = workSpace.connection as Connection;
  const wallet = workSpace.wallet;
  // console.log("IDDD", program?.programId.toString());
  useEffect(() => {
    (async () => {
      try {
        // console.log("WORKSPCE", workSpace)
        if (!wallet || !program) {
          return;
        }

       
       
        const fetchAllTweets = await program.account.tweet.all();
        if (fetchAllTweets.length === 0) {
          return [];
        }
        fetchAllTweets.sort((a, b) => b.account.timestamp.toNumber() - a.account.timestamp.toNumber());
        const tweets = getTweets(pageNo, 3, fetchAllTweets);


       
        if (tweets.length === 0) {
          return;
        }
        const tweetsWithUserLikes = setTweetsWithUserLike(allLikes,tweets,userLikes);
        setAllTweets(tweetsWithUserLikes);
      
      } catch (error) {
        alert("Something went wrong!!! Try again later")
        console.log("Error", error);
      }
      // setFetch();
    })();
  }, [wallet, fetchTweets, pageNo, allLikes, userLikes]);

  const setTweets = (tweets: Array<any>) => {
    setAllTweets(tweets);
  };

  const setPage = () => {
    setPageNo(pageNo + 1);
  }

  // const setFetch = () => {
  //   setFetchTweets(true);
  // }
  const value = { allTweets, setPage };

  return (
    <TweetsContext.Provider value={value}>{children}</TweetsContext.Provider>
  );
};

export default TweetsProvider;
